<template>
  <rect width="12" height="12" rx="6" fill="#FF595E" />
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M3.29289 3.29289C3.68342 2.90237 4.31658 2.90237 4.70711 3.29289L6 4.58579L7.29289 3.29289C7.68342 2.90237 8.31658 2.90237 8.70711 3.29289C9.09763 3.68342 9.09763 4.31658 8.70711 4.70711L7.41421 6L8.70711 7.29289C9.09763 7.68342 9.09763 8.31658 8.70711 8.70711C8.31658 9.09763 7.68342 9.09763 7.29289 8.70711L6 7.41421L4.70711 8.70711C4.31658 9.09763 3.68342 9.09763 3.29289 8.70711C2.90237 8.31658 2.90237 7.68342 3.29289 7.29289L4.58579 6L3.29289 4.70711C2.90237 4.31658 2.90237 3.68342 3.29289 3.29289Z"
    fill="white"
  />
</template>
